export const SUIVI_INTERVENTION = {
    SET_ITEMS: 'SET_SUIVI_INTERVENTION_ITEMS',
    RESET_ITEMS: 'RESET_SUIVI_INTERVENTION_ITEMS',
    ADD_ITEMS: 'ADD_SUIVI_INTERVENTION_ITEMS',

    SET_PAGE: 'SET_SUIVI_INTERVENTION_PAGE',
    SET_NB_OF_PAGES: 'SET_SUIVI_INTERVENTION_NB_OF_PAGES',
    SET_SCROLL: 'SET_SUIVI_INTERVENTION_SCROLL',
    SET_COUNT: 'SET_SUIVI_INTERVENTION_COUNT',

    SET_SORT: 'SET_DEMANDE_INTERVENTION_SORT',
    SET_FILTER_STATUS: 'SUIVI_INTERVENTION_SET_FILTER_STATUS',
    RESET_FILTER: 'SUIVI_INTERVENTION_RESET_FILTER',
    SET_FILTER_INTERVENTION_ID: 'SUIVI_INTERVENTION_SET_FILTER_INTERVENTION_ID',
    SET_FILTER_ONLY_MINE: 'SUIVI_INTERVENTION_SET_FILTER_ONLY_MINE',
    ADD_FILTER_SITE: 'SUIVI_INTERVENTION_ADD_FILTER_SITE',
    REMOVE_FILTER_SITE: 'SUIVI_INTERVENTION_REMOVE_FILTER_SITE',
    SET_FILTER_SITE: 'SUIVI_INTERVENTION_SET_FILTER_SITE',
    ADD_FILTER_STATUS: 'SUIVI_INTERVENTION_ADD_FILTER_STATUS',
    REMOVE_FILTER_STATUS: 'SUIVI_INTERVENTION_REMOVE_FILTER_STATUS',
    SET_FILTER_PREDICTED_DATE_FROM: 'SUIVI_INTERVENTION_SET_FILTER_PREDICTED_DATE_FROM',
    SET_FILTER_PREDICTED_DATE_TO: 'SUIVI_INTERVENTION_SET_FILTER_PREDICTED_DATE_TO',

    SET_IS_LOADING: 'SET_SUIVI_INTERVENTION_IS_LOADING',
    SET_ERROR: 'SET_SUIVI_INTERVENTION_ERROR',
    SET_SUCCESS: 'SET_SUIVI_INTERVENTION_SUCCESS',

    CLEAR_ALL: 'SUIVI_INTERVENTION_CLEAR_ALL',

    SET_EXPORT_XLS_IS_LOADING: 'SET_SUIVI_INTERVENTION_EXPORT_XLS_IS_LOADING',
};
